export function deleteNode({ setNodes, setEdges, nodeId }) {
  setNodes((prev) => {
    const childdrenNodes = prev.filter(
      (i) => i.id === nodeId || i.data?.parentData?.id === nodeId
    );

    childdrenNodes.forEach((nodeSelected) => {
      if (nodeSelected.data?.parentData?.id === "titleIntentNode") {
        prev = prev.filter(
          (i) =>
            i.id !== nodeSelected.id &&
            i.data?.parentData?.id !== nodeSelected.id
        );
      } else {
        prev = prev.filter(
          (i) =>
            i.id !== nodeSelected.id &&
            i.data?.parentData?.id !== nodeSelected.id
        );
      }
    });

    return prev;
  });
}


